import React, { useEffect, useState } from 'react';
import {
  LambdaLoaderCardStyles,
  LoaderTopRow,
  LoaderLabel,
  ProgressPercent,
  ProgressTrack,
  ProgressFill,
  ProgressHead,
} from './LambdaLoaderCard.styles';

// Purely a "give the user something to look at" timer — it has no idea when
// the scrapers will actually finish, so it climbs from START towards CAP (never
// 100, so it never visually lies about being done) over DURATION_MS, then just
// holds at CAP for as long as this card stays mounted (i.e. until the real
// allScrapperResulsGotten flags flip and the parent unmounts it). The rotating
// phrases below are on their own independent timer, purely to keep the wait
// feeling alive instead of staring at one static sentence.
const START_PROGRESS = 25;
const CAP_PROGRESS = 97;
const DURATION_MS = 75000;
const ALMOST_DONE_AT = 90;
const PHRASE_INTERVAL_MS = 3200;

const DEFAULT_PHRASES = [
  'Stiamo confrontando le tariffe migliori...',
  'Analizzando le compagnie assicurative...',
  'Calcolando il preventivo più conveniente...',
  'Verificando le coperture disponibili...',
];

function LambdaLoaderCard({
  phrases = DEFAULT_PHRASES,
  almostDoneLabel = 'Ritocchi finali, un attimo ancora...',
}) {
  const [progress, setProgress] = useState(START_PROGRESS);
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const startedAt = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      const ratio = Math.min(elapsed / DURATION_MS, 1);

      setProgress(START_PROGRESS + (CAP_PROGRESS - START_PROGRESS) * ratio);

      if (ratio >= 1) {
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseIndex((prev) => (prev + 1) % phrases.length);
    }, PHRASE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [phrases.length]);

  const isAlmostDone = progress >= ALMOST_DONE_AT;
  const currentLabel = isAlmostDone ? almostDoneLabel : phrases[phraseIndex];

  return (
    <LambdaLoaderCardStyles>
      <LoaderTopRow>
        <LoaderLabel key={currentLabel}>{currentLabel}</LoaderLabel>
        <ProgressPercent>
          {Math.round(progress)}
          %
        </ProgressPercent>
      </LoaderTopRow>

      <ProgressTrack>
        <ProgressFill style={{ width: `${progress}%` }}>
          <ProgressHead />
        </ProgressFill>
      </ProgressTrack>
    </LambdaLoaderCardStyles>
  );
}

export default LambdaLoaderCard;
